/* ==========================================================================
   MENJUNJES — Custom JavaScript for Shopify Prestige Theme
   Version: 2.0 — No external dependencies

   Load via theme.liquid before </body>:
   <script src="{{ 'menjunjes-custom.js' | asset_url }}" defer></script>
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     1. ANNOUNCEMENT BAR — Rotating cycle with pause/play, hover, focus, a11y
     ------------------------------------------------------------------------ */

  function initAnnouncementRotation() {
    var container = document.querySelector('.menjunjes-announcement');
    if (!container) return;

    var messages = container.querySelectorAll('.menjunjes-announcement__message');
    if (messages.length < 2) return;

    var pauseBtn = container.querySelector('.menjunjes-announcement__pause');
    var currentIndex = 0;
    var intervalMs = 5000;
    var intervalId = null;
    var isPaused = false;
    var isHovered = false;
    var isFocused = false;

    // Respect reduced motion
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (prefersReducedMotion.matches) {
      // Show first message, no rotation
      return;
    }

    // Activate the first message, set aria-hidden on others
    messages[0].classList.add('is-active');
    messages[0].removeAttribute('aria-hidden');

    function rotate() {
      messages[currentIndex].classList.remove('is-active');
      messages[currentIndex].setAttribute('aria-hidden', 'true');
      currentIndex = (currentIndex + 1) % messages.length;
      messages[currentIndex].classList.add('is-active');
      messages[currentIndex].removeAttribute('aria-hidden');
    }

    function startRotation() {
      if (!intervalId && !isPaused && !isHovered && !isFocused) {
        intervalId = setInterval(rotate, intervalMs);
      }
    }

    function stopRotation() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }

    // Pause when tab is hidden, resume when visible
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopRotation();
      } else {
        startRotation();
      }
    });

    // Pause/play button (WCAG 2.2.2)
    if (pauseBtn) {
      var pauseIcon = pauseBtn.querySelector('.menjunjes-announcement__pause-icon');
      var playIcon = pauseBtn.querySelector('.menjunjes-announcement__play-icon');

      pauseBtn.addEventListener('click', function () {
        isPaused = !isPaused;
        if (isPaused) {
          stopRotation();
          pauseBtn.setAttribute('aria-label', 'Play announcements');
          if (pauseIcon) pauseIcon.hidden = true;
          if (playIcon) playIcon.hidden = false;
        } else {
          pauseBtn.setAttribute('aria-label', 'Pause announcements');
          if (pauseIcon) pauseIcon.hidden = false;
          if (playIcon) playIcon.hidden = true;
          startRotation();
        }
      });
    }

    // Hover pause
    container.addEventListener('mouseenter', function () {
      isHovered = true;
      stopRotation();
    });

    container.addEventListener('mouseleave', function () {
      isHovered = false;
      startRotation();
    });

    // Focus pause — pause when any link inside gains focus
    container.addEventListener('focusin', function () {
      isFocused = true;
      stopRotation();
    });

    container.addEventListener('focusout', function () {
      isFocused = false;
      startRotation();
    });

    startRotation();
  }


  /* ------------------------------------------------------------------------
     2. GATHER VIDEO — Autoplay with pause button + reduced-motion
     ------------------------------------------------------------------------ */

  function initGatherVideo() {
    var videos = document.querySelectorAll('.menjunjes-video-feature__video');
    if (!videos.length) return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    videos.forEach(function (video) {
      var mediaContainer = video.closest('.menjunjes-video-feature__media');
      var pauseBtn = mediaContainer ? mediaContainer.querySelector('.menjunjes-video-feature__pause') : null;
      var fallback = mediaContainer ? mediaContainer.querySelector('.menjunjes-video-feature__image') : null;

      // Respect reduced-motion: don't autoplay, show fallback
      if (prefersReducedMotion.matches) {
        video.pause();
        video.removeAttribute('autoplay');
        if (fallback) {
          fallback.classList.remove('menjunjes-video-feature__image--hidden');
        }
        if (pauseBtn) pauseBtn.hidden = true;
        return;
      }

      // Ensure correct attributes
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.removeAttribute('controls');

      // Attempt autoplay
      var playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch(function () {
          // Autoplay blocked — show fallback image if present
          if (fallback) {
            fallback.classList.remove('menjunjes-video-feature__image--hidden');
            video.style.display = 'none';
          }
          if (pauseBtn) pauseBtn.hidden = true;
        });
      }

      // Pause/play button
      if (pauseBtn) {
        var pauseIcon = pauseBtn.querySelector('.menjunjes-video-feature__pause-icon');
        var playIcon = pauseBtn.querySelector('.menjunjes-video-feature__play-icon');

        pauseBtn.addEventListener('click', function () {
          if (video.paused) {
            video.play();
            pauseBtn.setAttribute('aria-label', 'Pause video');
            if (pauseIcon) pauseIcon.hidden = false;
            if (playIcon) playIcon.hidden = true;
          } else {
            video.pause();
            pauseBtn.setAttribute('aria-label', 'Play video');
            if (pauseIcon) pauseIcon.hidden = true;
            if (playIcon) playIcon.hidden = false;
          }
        });
      }
    });
  }


  /* ------------------------------------------------------------------------
     3. STAGGERED FADE-IN — IntersectionObserver for .blend-card elements
     ------------------------------------------------------------------------ */

  function initFadeInObserver() {
    var cards = document.querySelectorAll('.blend-card');
    if (!cards.length) return;

    // Fallback: if IntersectionObserver not supported, show all immediately
    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        card.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -40px 0px'
      }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }


  /* ------------------------------------------------------------------------
     4. BREWING ACCORDION — Toggle panels
     ------------------------------------------------------------------------ */

  function initBrewingAccordion() {
    var triggers = document.querySelectorAll('.menjunjes-brewing-accordion__trigger');
    if (!triggers.length) return;

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.menjunjes-brewing-accordion__item');
        var panel = item.querySelector('.menjunjes-brewing-accordion__panel');

        if (item.classList.contains('is-open')) {
          // Close
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          panel.style.maxHeight = null;
        } else {
          // Close all others
          document.querySelectorAll('.menjunjes-brewing-accordion__item.is-open').forEach(function (openItem) {
            openItem.classList.remove('is-open');
            openItem.querySelector('.menjunjes-brewing-accordion__trigger').setAttribute('aria-expanded', 'false');
            openItem.querySelector('.menjunjes-brewing-accordion__panel').style.maxHeight = null;
          });
          // Open this one
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }


  /* ------------------------------------------------------------------------
     5. NOTIFY ME — AJAX form submission for out-of-stock email capture
     ------------------------------------------------------------------------ */

  function initNotifyMe() {
    var forms = document.querySelectorAll('[data-notify-form]');
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var emailInput = form.querySelector('input[type="email"]');
        var email = emailInput.value.trim();

        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          emailInput.setCustomValidity('Please enter a valid email address');
          emailInput.reportValidity();
          return;
        }

        var button = form.querySelector('button[type="submit"]');
        button.disabled = true;
        button.textContent = 'Sending...';

        var companyId = form.getAttribute('data-klaviyo-company');
        var variantId = form.getAttribute('data-variant-id');
        var listId = form.getAttribute('data-klaviyo-list');
        var request;

        if (companyId && variantId) {
          // Primary: Klaviyo Back in Stock subscription -> auto-notifies this
          // person by email the moment this exact variant is restocked.
          var bisBody = {
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: email } } },
                channels: ['EMAIL']
              },
              relationships: {
                variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
              }
            }
          };
          request = fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
            body: JSON.stringify(bisBody)
          }).then(function (res) {
            if (!res.ok && res.status !== 202) { throw new Error('klaviyo back-in-stock failed'); }
          });

          // Secondary (fire-and-forget): keep them on the marketing waitlist
          // per the consent line, tagged with which product they wanted.
          if (listId) {
            var params = new URLSearchParams();
            params.append('g', listId);
            params.append('email', email);
            params.append('$fields', 'signup_source,notify_product,notify_product_url');
            params.append('signup_source', 'notify-me');
            params.append('notify_product', form.getAttribute('data-product-title') || '');
            params.append('notify_product_url', form.getAttribute('data-product-url') || '');
            fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              body: params.toString()
            }).catch(function () {});
          }
        } else {
          // No-JS-style fallback: native /contact submission
          request = fetch('/contact#contact_form', {
            method: 'POST',
            body: new FormData(form),
            headers: { 'Accept': 'text/html' }
          });
        }

        request
          .then(function () {
            var container = form.closest('.menjunjes-notify-me');
            var success = container.querySelector('[data-notify-success]');
            form.hidden = true;
            success.hidden = false;
          })
          .catch(function () {
            button.disabled = false;
            button.textContent = 'Notify me';
            emailInput.setCustomValidity('Something went wrong. Try again.');
            emailInput.reportValidity();
          });
      });
    });
  }


  /* ------------------------------------------------------------------------
     6. PRESTIGE ACCORDION ARIA SYNC — keep aria-expanded on <summary> in sync
     with the native [open] state of <details>. Improves screen-reader cover.
     ------------------------------------------------------------------------ */

  function initPrestigeAccordionAriaSync() {
    var detailsList = document.querySelectorAll('details.accordion__disclosure');
    detailsList.forEach(function (details) {
      var summary = details.querySelector('summary');
      if (!summary) return;
      details.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      });
    });
  }


  /* ------------------------------------------------------------------------
     INIT — Run when DOM is ready
     ------------------------------------------------------------------------ */

  function init() {
    initAnnouncementRotation();
    initGatherVideo();
    initFadeInObserver();
    initBrewingAccordion();
    initNotifyMe();
    initPrestigeAccordionAriaSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
